// client/src/components/Admin/Dashboard/_shared/VerticalSection.js
//
// M06 Fase 4 - Wrapper de una seccion vertical (K12 / REVI / Simulator /
// Otros). Compone SectionHeader + slot de body con manejo de error.

import React from "react";
import { SectionHeader } from "./SectionHeader";
import styles from "./VerticalSection.module.scss";

export function VerticalSection({ id, title, subtitle, error, children }) {
  return (
    <section className={styles.verticalSection}>
      <SectionHeader id={id} title={title} subtitle={subtitle} />
      <div className={styles.body}>
        {error ? <div className={styles.errorBox}>{error}</div> : null}
        {children}
      </div>
    </section>
  );
}
